import {
  faBookMedical,
  faCalendarAlt,
  faCancel,
  faClinicMedical,
  faClock,
  faHouse,
  faPeopleArrows,
  faUserClock,
  faVideoCamera
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Col, Popconfirm, Space, Tag, Tooltip } from 'antd'
import theme from '../../../core/utils/theme'
import dayjs from 'dayjs'
import Store from '../../../store'
import { generateStatus } from '../../lib/booking-utils'
import CustomRow from '../../reusable-components/CustomRow'
import CoreEnums from '../../../core/utils/enums'

// const joinVirtualConsult = async () => {
//   let agoraCreds = null

//   try {
//     agoraCreds = await generateAgoraRtcToken(data._id, 2)
//     setAgoraToken(agoraCreds.token)
//     setAgoraChannel(agoraCreds.channelName)
//     setAgoraUid(agoraCreds.uid)
//     setJoined(true)
//   } catch (e) {
//     message.error(handleError(e, true))
//   }
// }

const templates = {
  dataModel: {},
  columnTemplate: (
    token,
    cancelBooking,
    handleExamination,
    filterValue,
    handleReassignment,
    wasNoShow,
    joinVirtualConsult,
    handleReschedule,
    markNoShow
  ) => {
    const state = Store.getState()

    return [
      // Small Screens
      {
        title: 'Record',
        key: 'column1',
        responsive: ['xs'],
        render: (text, record) => {
          return (
            <CustomRow gutter={[4, 4]} style={{ textAlign: 'center' }}>
              <Col span={24}>
                <h2>
                  {record.isVirtualVisit
                    ? // Only use default clinic for flexi/priority consultations without assigned practitioner
                      (record.serviceType === 'flexi' ||
                        record.consultType === 'flexi' ||
                        record.serviceType === 'priority' ||
                        record.consultType === 'priority' ||
                        record.isPriorityConsult) &&
                      !record.medicalProf
                      ? 'Meta-Health Virtual Clinic'
                      : record.clinicName || 'Meta-Health Virtual Clinic'
                    : record.clinicName
                    ? record.clinicName
                    : 'Home Visit'}
                </h2>
              </Col>
              <Col span={24}>
                <p>
                  {record.claimable && !record.medicalProfName
                    ? 'Doctor to be assigned'
                    : record.medicalProfName || 'Meta-Health Verified Doctor'}
                  {record.claimable && (
                    <Tag color='orange' style={{ marginLeft: 8 }}>
                      {record.appointmentType === 'priority' ? 'PRIORITY' : 'FLEXI'}
                    </Tag>
                  )}
                </p>
              </Col>
              <Col span={24}>
                <p>
                  {(() => {
                    // Handle date parsing for flexi consultations
                    let displayDate
                    if (record.bookingDate && dayjs(record.bookingDate).isValid()) {
                      displayDate = dayjs(record.bookingDate).format('DD MMM YYYY')
                    } else if (record.dateCreated && dayjs(record.dateCreated).isValid()) {
                      // For flexi consultations, use dateCreated as fallback
                      displayDate = dayjs(record.dateCreated).format('DD MMM YYYY')
                    } else {
                      displayDate = 'Invalid Date'
                    }
                    const displayTime = record.startTime || dayjs(record.dateCreated).format('HH:mm')
                    return `${displayDate} (${displayTime})`
                  })()}
                </p>
              </Col>

              {record.status === CoreEnums.bookingStatuses.checkin ||
              record.status === CoreEnums.bookingStatuses.screening ? (
                <Col span={24}>
                  <Button
                    style={{ width: '100%' }}
                    onClick={(e) => {
                      e.stopPropagation()
                      cancelBooking(record)
                    }}
                  >
                    <Space>
                      <FontAwesomeIcon size='md' color={theme.twitterBootstrap.danger} icon={faCancel} />
                      <div style={{ color: theme.twitterBootstrap.danger, fontSize: 12 }}>Cancel</div>
                    </Space>
                  </Button>
                </Col>
              ) : undefined}
              {record.isVirtualVisit ? (
                <Col span={24}>
                  <Tag color={token.colorSecondary}>Virtual Consultation</Tag>
                </Col>
              ) : undefined}
              {record.status === CoreEnums.bookingStatuses.consultation && record.isVirtualVisit ? (
                <Col span={24}>
                  <Popconfirm
                    title='Confirmation'
                    description='Are you sure you want to Join the Virtual Consultation?'
                    okText='Yes'
                    cancelText='No'
                    onConfirm={(e) => {
                      e.stopPropagation()
                      joinVirtualConsult(record)
                    }}
                    onCancel={(e) => {
                      e.stopPropagation()
                    }}
                    okButtonProps={{ danger: true }}
                  >
                    <Button onClick={(e) => e.stopPropagation()} type='primary'>
                      <Space>
                        <FontAwesomeIcon icon={faVideoCamera} />
                        Join
                      </Space>
                    </Button>
                  </Popconfirm>
                </Col>
              ) : undefined}
            </CustomRow>
          )
        }
      },
      // {
      //   title: 'Actions',
      //   width: '50%',
      //   key: 'column2',
      //   responsive: ['xs'],
      //   render: (text, record) => {
      //     return (
      //       <Row gutter={[8, 8]}>

      //       </Row>
      //     )
      //   }
      // },
      // Medium Screens and Up
      {
        title: 'Patient',
        hidden:
          state.auth.agiliteUser?.extraData.role.type === 'admin' ||
          state.auth.agiliteUser?.extraData.role.type === 'reception' ||
          state.auth.agiliteUser?.extraData.role.type === 'medical_professional'
            ? false
            : true,
        dataIndex: 'patientName',
        key: 'individual2',
        responsive: ['sm']
      },
      {
        title: 'Date / Time',
        dataIndex: 'date',
        key: 'date',
        render: (text, record) => {
          const displayTime = record.startTime || dayjs(record.dateCreated).format('HH:mm')

          // Debug logging for date issues
          if (record.isVirtualVisit && (!record.medicalProf || !record.startTime)) {
            console.log('🔍 Date parsing debug for flexi/priority appointment:', {
              recordId: record._id,
              bookingDate: record.bookingDate,
              bookingDateValid: record.bookingDate ? dayjs(record.bookingDate).isValid() : false,
              dateCreated: record.dateCreated,
              dateCreatedValid: record.dateCreated ? dayjs(record.dateCreated).isValid() : false,
              startTime: record.startTime
            })
          }

          // Handle date parsing for flexi consultations
          let displayDate
          if (record.bookingDate && dayjs(record.bookingDate).isValid()) {
            displayDate = dayjs(record.bookingDate).format('DD MMM YYYY')
          } else if (record.dateCreated && dayjs(record.dateCreated).isValid()) {
            // For flexi consultations, use dateCreated as fallback
            displayDate = dayjs(record.dateCreated).format('DD MMM YYYY')
          } else {
            displayDate = 'Invalid Date'
          }

          return (
            <>
              {displayDate} - {displayTime}
            </>
          )
        },
        responsive: ['sm']
      },
      {
        title: 'Practitioner',
        hidden:
          state.auth.agiliteUser?.extraData.role.type === 'medical_professional' &&
          state.auth.agiliteUser?.extraData.profession === 'doctor' &&
          !state.auth.agiliteUser?.extraData.role.isManager
            ? true
            : false,
        dataIndex: 'medicalProfName',
        key: 'individual',
        render: (text, record) => {
          return record.medicalProfName || 'Meta-Health Verified Doctor'
        },
        responsive: ['sm']
      },
      {
        title: 'Clinic',
        hidden:
          state.auth.agiliteUser?.extraData.role.type !== 'reception' &&
          (filterValue === undefined || filterValue !== 'home')
            ? false
            : true,
        dataIndex: 'clinicName',
        key: 'clinic',
        responsive: ['sm'],
        render: (text, record) => {
          if (record.isVirtualVisit) {
            // Only use default clinic for flexi/priority consultations without assigned practitioner
            if (
              (record.serviceType === 'flexi' ||
                record.consultType === 'flexi' ||
                record.serviceType === 'priority' ||
                record.consultType === 'priority' ||
                record.isPriorityConsult) &&
              !record.medicalProf
            ) {
              return 'Meta-Health Virtual Clinic'
            }
            // For scheduled virtual or assigned consultations, show the actual clinic
            return record.clinicName || 'Meta-Health Virtual Clinic'
          } else if (record.clinicName) {
            return <>{record.clinicName}</>
          } else {
            return 'Home Visit'
          }
        }
      },
      {
        title: 'Reason For Consult',
        hidden:
          state.auth.agiliteUser?.extraData.role.type === 'medical_professional' ||
          state.auth.agiliteUser?.extraData.role.type === 'admin'
            ? false
            : true,
        dataIndex: 'chiefComplaint',
        key: 'chiefComplaint',
        responsive: ['sm']
      },
      {
        title: 'OTP',
        hidden:
          state.auth.agiliteUser?.extraData.role.type === 'patient' ||
          state.auth.agiliteUser?.extraData.role.type === 'reception' ||
          (state.auth.agiliteUser?.extraData.role.type === 'medical_professional' &&
            state.auth.agiliteUser?.extraData.profession === 'nurse')
            ? false
            : true,
        dataIndex: 'otp',
        key: 'otp',
        responsive: ['sm']
      },
      {
        title: 'Consultation Type',
        hidden:
          state.auth.agiliteUser?.extraData.role.type === 'patient' ||
          state.auth.agiliteUser?.extraData.role.type === 'reception' ||
          (state.auth.agiliteUser?.extraData.role.type === 'medical_professional' &&
            state.auth.agiliteUser?.extraData.profession === 'doctor')
            ? false
            : true,
        key: 'isVirtualVisit',
        render: (text, record) => {
          const getConsultationType = () => {
            // Debug logging to see what properties are available
            if (record.isVirtualVisit) {
              const serviceData =
                state.services && state.services.data ? state.services.data.find((s) => s._id === record.service) : null

              console.log('🔍 Virtual consultation record properties:', {
                recordId: record._id,
                serviceType: record.serviceType,
                consultType: record.consultType,
                isPriorityConsult: record.isPriorityConsult,
                serviceName: record.serviceName,
                serviceId: record.service,
                serviceData: serviceData,
                medicalProf: record.medicalProf,
                startTime: record.startTime,
                clinicName: record.clinicName,
                isFlexiOrPriority: !record.medicalProf && !record.startTime
              })
            }

            if (record.isVirtualVisit) {
              // Enhanced detection logic
              const isFlexiOrPriority = !record.medicalProf && !record.startTime
              let serviceName = (record.serviceName || '').toLowerCase()

              // Try to lookup service name from services data if we have a service ID
              if (!serviceName && record.service && state.services && state.services.data) {
                const serviceData = state.services.data.find((s) => s._id === record.service)
                if (serviceData) {
                  serviceName = (serviceData.name || serviceData.label || '').toLowerCase()
                }
              }

              // Check for Priority Virtual
              if (
                record.isPriorityConsult ||
                record.serviceType === 'priority' ||
                record.consultType === 'priority' ||
                serviceName.includes('priority') ||
                serviceName.includes('urgent') ||
                serviceName.includes('immediate')
              ) {
                return {
                  text: 'Priority Virtual',
                  icon: faVideoCamera,
                  color: '#ff4d4f' // Red color for priority/urgent
                }
              }
              // Check for Flexi Virtual
              else if (
                record.serviceType === 'flexi' ||
                record.consultType === 'flexi' ||
                serviceName.includes('flexi') ||
                (isFlexiOrPriority && !serviceName.includes('priority'))
              ) {
                return {
                  text: 'Flexi Virtual',
                  icon: faVideoCamera,
                  color: '#52c41a' // Green color for flexi
                }
              }
              // Default to Scheduled Virtual
              else {
                return {
                  text: 'Scheduled Virtual',
                  icon: faVideoCamera,
                  color: '#1890ff' // Blue color for scheduled virtual
                }
              }
            } else if (record.clinicRef === 'Home Visit') {
              return {
                text: 'Home Visit',
                icon: faHouse,
                color: '#fa8c16' // Orange color for home visits
              }
            } else {
              return {
                text: 'In-Person',
                icon: faClinicMedical,
                color: '#722ed1' // Purple color for clinic visits
              }
            }
          }

          const consultationType = getConsultationType()

          return (
            <Space size='small' align='center'>
              <FontAwesomeIcon
                icon={consultationType.icon}
                style={{ color: consultationType.color, fontSize: '14px' }}
              />
              <span style={{ color: consultationType.color, fontWeight: '500' }}>{consultationType.text}</span>
            </Space>
          )
        },
        responsive: ['sm']
      },
      {
        title: 'Status',
        key: 'status',
        render: (text, record) => {
          return generateStatus(record, record?.status, token, record?.wasNoShow)
        },
        responsive: ['sm']
      },
      {
        title: 'Actions',
        render: (text, record) => {
          const handleVirtualConsultAction = () => {
            if (
              record.status === CoreEnums.bookingStatuses.consultation &&
              state.auth.agiliteUser?.extraData.role.type === 'patient' &&
              record.isVirtualVisit
            ) {
              return [true]
            }

            return [false]
          }

          const handleExaminationAction = () => {
            if (
              record.status === CoreEnums.bookingStatuses.consultation &&
              state.auth.agiliteUser?.extraData.role.type === 'medical_professional' &&
              state.auth.agiliteUser?.extraData.profession !== 'nurse' &&
              state.auth.agiliteUser?.extraData.profession !== 'reception'
            ) {
              return [true, 'Begin Examination']
            }

            if (
              record.status === CoreEnums.bookingStatuses.screening &&
              state.auth.agiliteUser?.extraData.profession === 'nurse'
            ) {
              return [true, 'Begin Examination']
            }

            if (
              record.status === CoreEnums.bookingStatuses.reception &&
              state.auth.agiliteUser?.extraData.role.type === 'reception'
            ) {
              if (
                state.auth.agiliteUser?.extraData.clinics.includes(record.clinicRef) ||
                record.clinicRef === 'Home Visit'
              ) {
                return [true, 'Finalize Booking']
              }
            }

            if (
              record.status === CoreEnums.bookingStatuses.screening &&
              state.auth.agiliteUser?.extraData.role.type === 'medical_professional' &&
              state.auth.agiliteUser?.extraData.profession === 'nurse'
            ) {
              return [true, 'Begin Procedure']
            }

            return [false, '']
          }

          const handleReAssignmentAction = () => {
            if (
              record.status === CoreEnums.bookingStatuses.checkin ||
              record.status === CoreEnums.bookingStatuses.screening
            ) {
              if (
                state.auth.agiliteUser?.extraData.role.type === 'medical_professional' &&
                state.auth.agiliteUser?.extraData.profession === 'doctor'
              ) {
                if (record.clinicRef !== 'Home Visit') {
                  return [true, 'Re-Assign']
                }
              }
            }

            return [false, '']
          }

          const handleCancelAction = () => {
            // Early return for no-show appointments
            if (record.wasNoShow) {
              return { allowed: false, reason: 'Cannot cancel - appointment marked as no-show.' }
            }

            // Early return for already cancelled appointments
            if (record.status === CoreEnums.bookingStatuses.cancelled) {
              return { allowed: false, reason: 'Cannot cancel - appointment is already cancelled.' }
            }

            // Early return for completed appointments
            if (record.status === CoreEnums.bookingStatuses.completed) {
              return { allowed: false, reason: 'Cannot cancel - appointment is already completed.' }
            }

            // Check if appointment is within 3-hour cancellation window for patients
            if (state.auth.agiliteUser?.extraData.role.type === 'patient') {
              // Special handling for flexi/priority consultations - they can be cancelled anytime before being assigned
              if (
                record.serviceType === 'flexi' ||
                record.consultType === 'flexi' ||
                record.serviceType === 'priority' ||
                record.consultType === 'priority' ||
                record.isPriorityConsult
              ) {
                if (!record.medicalProf && !record.startTime) {
                  return { allowed: true } // Allow cancellation if not yet assigned
                }
              }

              if ((record.bookingDate || record.dateCreated) && (record.startTime || record.dateCreated)) {
                // Parse date and time more robustly
                let appointmentDateTime
                if (record.startTime && record.bookingDate) {
                  const appointmentDate = dayjs(record.bookingDate)
                  const [hours, minutes] = record.startTime.split(':')
                  appointmentDateTime = appointmentDate.hour(parseInt(hours)).minute(parseInt(minutes)).second(0)
                } else {
                  // For flexi consultations, use dateCreated
                  appointmentDateTime = dayjs(record.dateCreated)
                }

                console.log('🔍 Cancel button parsing:', {
                  rawDate: record.bookingDate,
                  rawTime: record.startTime || 'using dateCreated',
                  dateCreated: record.dateCreated,
                  parsedDateTime: appointmentDateTime.format(),
                  isValid: appointmentDateTime.isValid()
                })

                if (!appointmentDateTime.isValid()) {
                  return { allowed: false, reason: 'Cannot cancel - invalid appointment date/time.' }
                }

                const currentTime = dayjs()
                const hoursUntilAppointment = appointmentDateTime.diff(currentTime, 'hours', true)
                const appointmentInPast = appointmentDateTime.isBefore(currentTime)

                console.log('🔍 Cancel button validation:', {
                  appointmentDateTime: appointmentDateTime.format(),
                  currentTime: currentTime.format(),
                  hoursUntilAppointment: hoursUntilAppointment.toFixed(2),
                  appointmentInPast: appointmentInPast
                })

                // Patient cannot cancel if appointment has already passed
                if (appointmentInPast) {
                  return { allowed: false, reason: 'Cannot cancel - appointment has already passed.' }
                }

                // Patient cannot cancel if appointment is less than 3 hours away
                if (hoursUntilAppointment < 3) {
                  return {
                    allowed: false,
                    reason: `Cannot cancel - appointment in ${hoursUntilAppointment.toFixed(
                      1
                    )} hours. Must be 3+ hours in advance.`
                  }
                }
              } else {
                return { allowed: false, reason: 'Cannot cancel - missing appointment date/time.' }
              }
            }

            // Check status-based permissions
            if (record.status === CoreEnums.bookingStatuses.checkin) {
              if (
                state.auth.agiliteUser?.extraData.role.type === 'patient' ||
                state.auth.agiliteUser?.extraData.role.type === 'reception'
              ) {
                return { allowed: true }
              }
            } else if (record.status === CoreEnums.bookingStatuses.screening) {
              if (record.clinicRef === 'Home Visit' || state.auth.agiliteUser?.extraData.role.type === 'reception') {
                return { allowed: true }
              }
            } else if (record.callpayGatewayReference && record.status !== CoreEnums.bookingStatuses.cancelled) {
              return { allowed: true }
            }

            return { allowed: false, reason: 'Cancellation not allowed for this appointment.' }
          }

          const handleRescheduleAction = () => {
            // Early return for no-show appointments
            if (record.wasNoShow) {
              return { allowed: false, reason: 'Cannot reschedule - appointment marked as no-show.' }
            }

            // Early return for already cancelled appointments
            if (record.status === CoreEnums.bookingStatuses.cancelled) {
              return { allowed: false, reason: 'Cannot reschedule - appointment is already cancelled.' }
            }

            // Early return for completed appointments
            if (record.status === CoreEnums.bookingStatuses.completed) {
              return { allowed: false, reason: 'Cannot reschedule - appointment is already completed.' }
            }

            // Check if appointment is within 1-hour rescheduling window for patients
            if (state.auth.agiliteUser?.extraData.role.type === 'patient') {
              // Special handling for flexi/priority consultations - they can be rescheduled anytime before being assigned
              if (
                record.serviceType === 'flexi' ||
                record.consultType === 'flexi' ||
                record.serviceType === 'priority' ||
                record.consultType === 'priority' ||
                record.isPriorityConsult
              ) {
                if (!record.medicalProf && !record.startTime) {
                  return { allowed: true } // Allow rescheduling if not yet assigned
                }
              }

              if ((record.bookingDate || record.dateCreated) && (record.startTime || record.dateCreated)) {
                // Parse date and time more robustly
                let appointmentDateTime
                if (record.startTime && record.bookingDate) {
                  const appointmentDate = dayjs(record.bookingDate)
                  const [hours, minutes] = record.startTime.split(':')
                  appointmentDateTime = appointmentDate.hour(parseInt(hours)).minute(parseInt(minutes)).second(0)
                } else {
                  // For flexi consultations, use dateCreated
                  appointmentDateTime = dayjs(record.dateCreated)
                }

                console.log('🔍 Reschedule button parsing:', {
                  rawDate: record.bookingDate,
                  rawTime: record.startTime || 'using dateCreated',
                  dateCreated: record.dateCreated,
                  parsedDateTime: appointmentDateTime.format(),
                  isValid: appointmentDateTime.isValid()
                })

                if (!appointmentDateTime.isValid()) {
                  return { allowed: false, reason: 'Cannot reschedule - invalid appointment date/time.' }
                }

                const currentTime = dayjs()
                const hoursUntilAppointment = appointmentDateTime.diff(currentTime, 'hours', true)
                const appointmentInPast = appointmentDateTime.isBefore(currentTime)

                console.log('🔍 Reschedule button validation:', {
                  appointmentDateTime: appointmentDateTime.format(),
                  currentTime: currentTime.format(),
                  hoursUntilAppointment: hoursUntilAppointment.toFixed(2),
                  appointmentInPast: appointmentInPast
                })

                // Patient cannot reschedule if appointment has already passed
                if (appointmentInPast) {
                  return { allowed: false, reason: 'Cannot reschedule - appointment has already passed.' }
                }

                // Patient cannot reschedule if appointment is less than 1 hour away
                if (hoursUntilAppointment < 1) {
                  return {
                    allowed: false,
                    reason: `Cannot reschedule - appointment in ${hoursUntilAppointment.toFixed(
                      1
                    )} hours. Must be 1+ hours in advance.`
                  }
                }
              } else {
                return { allowed: false, reason: 'Cannot reschedule - missing appointment date/time.' }
              }
            }

            // Check status-based permissions
            if (record.status === CoreEnums.bookingStatuses.checkin) {
              if (
                state.auth.agiliteUser?.extraData.role.type === 'patient' ||
                state.auth.agiliteUser?.extraData.role.type === 'reception'
              ) {
                return { allowed: true }
              }
            } else if (record.status === CoreEnums.bookingStatuses.screening) {
              if (record.clinicRef === 'Home Visit' || state.auth.agiliteUser?.extraData.role.type === 'reception') {
                return { allowed: true }
              }
            } else if (record.callpayGatewayReference && record.status !== CoreEnums.bookingStatuses.cancelled) {
              return { allowed: true }
            }

            return { allowed: false, reason: 'Rescheduling not allowed for this appointment.' }
          }

          const handleMarkNoShowAction = () => {
            // Early return if already marked as no-show
            if (record.wasNoShow) {
              return { allowed: false, reason: 'Appointment already marked as no-show.' }
            }

            // Early return for completed/cancelled appointments
            if (
              record.status === CoreEnums.bookingStatuses.completed ||
              record.status === CoreEnums.bookingStatuses.cancelled
            ) {
              return { allowed: false, reason: 'Cannot mark as no-show - appointment is completed or cancelled.' }
            }

            // Only show for reception and medical professionals
            if (
              state.auth.agiliteUser?.extraData.role.type !== 'reception' &&
              state.auth.agiliteUser?.extraData.role.type !== 'medical_professional'
            ) {
              return { allowed: false, reason: 'No-show marking not available for this user type.' }
            }

            // Only show for appointments in check-in status
            if (record.status !== CoreEnums.bookingStatuses.checkin) {
              return { allowed: false, reason: 'Can only mark check-in appointments as no-show.' }
            }

            // Check if appointment is 3+ hours overdue
            if ((record.bookingDate || record.dateCreated) && (record.startTime || record.dateCreated)) {
              let appointmentDateTime
              if (record.startTime && record.bookingDate) {
                const appointmentDate = dayjs(record.bookingDate)
                const [hours, minutes] = record.startTime.split(':')
                appointmentDateTime = appointmentDate.hour(parseInt(hours)).minute(parseInt(minutes)).second(0)
              } else {
                // For flexi consultations, use dateCreated
                appointmentDateTime = dayjs(record.dateCreated)
              }

              if (!appointmentDateTime.isValid()) {
                return { allowed: false, reason: 'Cannot determine appointment time.' }
              }

              const currentTime = dayjs()
              const hoursOverdue = currentTime.diff(appointmentDateTime, 'hours', true)

              console.log('🔍 No-show detection:', {
                appointmentDateTime: appointmentDateTime.format(),
                currentTime: currentTime.format(),
                hoursOverdue: hoursOverdue.toFixed(2),
                eligibleForNoShow: hoursOverdue >= 3
              })

              // Show action only if appointment is 3+ hours overdue
              if (hoursOverdue >= 3) {
                return {
                  allowed: true,
                  reason: `Mark as no-show - appointment ${hoursOverdue.toFixed(1)} hours overdue.`
                }
              } else {
                const hoursUntilEligible = 3 - hoursOverdue
                return {
                  allowed: false,
                  reason: `Too early to mark as no-show - wait ${hoursUntilEligible.toFixed(1)} more hours.`
                }
              }
            }

            return { allowed: false, reason: 'Missing appointment date/time.' }
          }

          return (
            <>
              {handleVirtualConsultAction()[0] ? (
                <center>
                  <Popconfirm
                    title='Confirmation'
                    description='Are you sure you want to Join the Virtual Consultation?'
                    okText='Yes'
                    cancelText='No'
                    onConfirm={(e) => {
                      e.stopPropagation()
                      joinVirtualConsult(record)
                    }}
                    onCancel={(e) => {
                      e.stopPropagation()
                    }}
                    okButtonProps={{ danger: true }}
                  >
                    <Button onClick={(e) => e.stopPropagation()} type='primary'>
                      <Space>
                        <FontAwesomeIcon icon={faVideoCamera} />
                        Join
                      </Space>
                    </Button>
                  </Popconfirm>
                </center>
              ) : (
                <Space size='large'>
                  {(() => {
                    const cancelResult = handleCancelAction()
                    if (cancelResult && cancelResult.allowed !== undefined) {
                      return (
                        <>
                          {state.auth.agiliteUser?.extraData.role.type === 'patient' ||
                          state.auth.agiliteUser?.extraData.role.type === 'reception' ? (
                            <Tooltip title={cancelResult.allowed ? 'Cancel Booking' : cancelResult.reason}>
                              <FontAwesomeIcon
                                size='lg'
                                id='cancel-booking'
                                color={cancelResult.allowed ? theme.twitterBootstrap.danger : token.colorTextDisabled}
                                icon={faCancel}
                                style={{
                                  cursor: cancelResult.allowed ? 'pointer' : 'not-allowed',
                                  opacity: cancelResult.allowed ? 1 : 0.5
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  if (cancelResult.allowed) {
                                    cancelBooking(record)
                                  }
                                }}
                              />
                            </Tooltip>
                          ) : undefined}
                        </>
                      )
                    }
                    return undefined
                  })()}
                  {(() => {
                    const rescheduleResult = handleRescheduleAction()
                    if (rescheduleResult && rescheduleResult.allowed !== undefined) {
                      return (
                        <>
                          {state.auth.agiliteUser?.extraData.role.type === 'patient' ||
                          state.auth.agiliteUser?.extraData.role.type === 'reception' ? (
                            <Tooltip
                              title={rescheduleResult.allowed ? 'Reschedule Appointment' : rescheduleResult.reason}
                            >
                              <FontAwesomeIcon
                                size='lg'
                                id='reschedule-booking'
                                color={rescheduleResult.allowed ? token.colorPrimary : token.colorTextDisabled}
                                icon={faCalendarAlt}
                                style={{
                                  cursor: rescheduleResult.allowed ? 'pointer' : 'not-allowed',
                                  opacity: rescheduleResult.allowed ? 1 : 0.5
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  if (rescheduleResult.allowed && handleReschedule) {
                                    handleReschedule(record)
                                  }
                                }}
                              />
                            </Tooltip>
                          ) : undefined}
                        </>
                      )
                    }
                    return undefined
                  })()}
                  {(() => {
                    const markNoShowResult = handleMarkNoShowAction()
                    if (markNoShowResult && markNoShowResult.allowed !== undefined) {
                      return (
                        <>
                          {state.auth.agiliteUser?.extraData.role.type === 'reception' ||
                          state.auth.agiliteUser?.extraData.role.type === 'medical_professional' ? (
                            <Tooltip title={markNoShowResult.allowed ? 'Mark as No Show' : markNoShowResult.reason}>
                              <FontAwesomeIcon
                                size='lg'
                                id='mark-no-show'
                                color={markNoShowResult.allowed ? token.colorWarning : token.colorTextDisabled}
                                icon={faUserClock}
                                style={{
                                  cursor: markNoShowResult.allowed ? 'pointer' : 'not-allowed',
                                  opacity: markNoShowResult.allowed ? 1 : 0.5
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  if (markNoShowResult.allowed && markNoShow) {
                                    markNoShow(record)
                                  }
                                }}
                              />
                            </Tooltip>
                          ) : undefined}
                        </>
                      )
                    }
                    return undefined
                  })()}
                  {handleExaminationAction()[0] ? (
                    <Tooltip title={handleExaminationAction()[1]}>
                      <FontAwesomeIcon
                        size='lg'
                        id='begin-examination'
                        color={theme.twitterBootstrap.success}
                        icon={faBookMedical}
                        onClick={(e) => {
                          e.stopPropagation()
                          handleExamination(record, state.auth.agiliteUser?.extraData.profession)
                        }}
                      />
                    </Tooltip>
                  ) : undefined}
                  {handleReAssignmentAction()[0] ? (
                    <Tooltip title={handleReAssignmentAction()[1]}>
                      <FontAwesomeIcon
                        size='lg'
                        id='re-assign'
                        color={token.colorSecondary}
                        icon={faPeopleArrows}
                        onClick={(e) => {
                          e.stopPropagation()
                          handleReassignment(record, state.auth.agiliteUser?.extraData.profession)
                        }}
                      />
                    </Tooltip>
                  ) : undefined}
                </Space>
              )}
            </>
          )
        },
        responsive: ['sm']
      }
    ]
  }
}

export default templates
